<div class="flex-column-container favorites-container">
  <div class="favorites background-container-background favorites-results-container">
    @for (favouriteItemGroup of favouriteItems | keyvalue; track favouriteItemGroup) {
      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <i [ngClass]="serviceTypeIconClasses[favouriteItemGroup.key]" aria-hidden="true"></i>
              <span class="favorites-title">
                {{ serviceTypeNames[favouriteItemGroup.key] }}
              </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="flex-column-container">
            @for (favouriteItem of favouriteItemGroup.value; track favouriteItem) {
              <div class="flex-row-container flex-row-container--between">
                <button
                  class="favourite-item-button"
                  (click)="favouritySelected(favouriteItem)"
                  (keydown.enter)="favouritySelected(favouriteItem)"
                  (keydown.space)="favouritySelected(favouriteItem)"
                  role="button"
                  tabindex="0"
                >
                  <div class="flex-column-container favorites-results-description">
                    <span class="visuallyhidden" i18n="@@selectFaveSearch"
                      >Select favourite search</span
                    >
                    <b>{{ favouriteItem.name }}</b>
                    <span>{{ getTitle(favouriteItem) }}</span>
                  </div>
                </button>
                <button
                  mat-icon-button
                  (click)="removeFavourite(favouriteItem)"
                  (keydown.enter)="removeFavourite(favouriteItem)"
                  (keydown.space)="removeFavourite(favouriteItem)"
                  class="remove-button"
                  tabindex="0"
                  aria-label="Remove favourite search {{ favouriteItem.name }}"
                >
                  <span class="visuallyhidden">Remove favourite search</span>
                  <span class="visuallyhidden">{{ favouriteItem.name }}</span>
                  @if (!isRemoving) {
                    <fa-icon [icon]="trash" aria-hidden="true"></fa-icon>
                  }
                  @if (isRemoving) {
                    <span role="status" aria-live="polite" aria-label="Removing favourite">
                      <fa-icon [icon]="spinner" aria-hidden="true"></fa-icon>
                    </span>
                  }
                </button>
              </div>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    }
    @if (!favouriteItems || !(favouriteItems | keyvalue).length) {
      <div class="recent_searches_no_recent">
        <fa-icon
          [icon]="faStar"
          placement="bottom"
          container="body"
          class="no_recent_icon"
          aria-hidden="true"
        >
        </fa-icon>
        <h2 class="no_recent_header" i18n="@@YouHaveNoFavs">You have no favourite searches</h2>
        <p class="no_recent_tag_line" i18n="@@YouHaveNoFavsMessage">
          To add a favourite search go to the search form, enter your favourite search and select
          the add to favourites button at the end of the page.
        </p>
      </div>
    }
  </div>
</div>
